import primary from "./primary.module.scss";
import secondary from "./secondary.module.scss";
import third from "./third.module.scss";
import success from "./success.module.scss";
import error from "./error.module.scss";
import fourth from "./fourth.module.scss";
import fifth from "./fifth.module.scss";

export default {
  primary,
  secondary,
  success,
  error,
  third,
  fourth,
  fifth
};
